import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './AdminWorkInfoScreen';
import AdminWorkInfo from './AdminWorkInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getAdminWork } from 'src/store/actions/adminWork-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        adminWork: state.adminWorks.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getAdminWork(id)),
    };
}

const AdminWorkInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(AdminWorkInfo);

export default AdminWorkInfoScreen;
